/**
 * 成员管理关接口
 * 接口文档 参考问题管理
 * @type {{login: string}}
 */
const myInvitation = {
  // 根据项目ID,获取成员列表
  getOwnedUserPageList: '/api/AccountManagement/GetOwnedUserPageList',
  // 移除用户
  removeOwnedUser: '/api/AccountManagement/RemoveOwnedUser',
}

Object.freeze(myInvitation)
export default myInvitation
